import React, { useState, useEffect, useRef } from "react";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import Form from "react-bootstrap/Form";
import { Row, Col, Card } from "react-bootstrap";
import Constants from "../../../../common/Constants";
import Button from "react-bootstrap/Button";
import MasterList from "../../../common/MasterList";
import ItemService from "../../../../services/commonService";
import ListGroup from "react-bootstrap/ListGroup";
import { DropdownListField } from "../../../../common/formElements/DropdownListField";
import { useTranslation } from "react-i18next";
import {
  fetchMasterList,
  fetchMasterListById,
} from "../../../../redux/feature/manufacturing_app/commonMasterListSlice";
import { useNavigate } from "react-router-dom";
import { formatDate, formatDateTime, calculateDuration, addTimeStrings } from "../../../../common/Validations";
import { toastFunc } from "../../../../components/common/util";
import { AlertModal } from "../../../common/AlertModal";
import { InputField } from "../../../../common/formElements/InputField";

const ReworkJobCard = () => {
  const navigate = useNavigate();

  const [jobcardDetails, setJobcardDetails] = useState();
  const [fromValue, setFromValue] = useState();
  const [finalToMachineCode, setFinalToMachineCode] = useState("");
  const [finalToMachineName, setFinalToMachineName] = useState("");
  const [toDeptCode, setToDeptCode] = useState("");
  const [displayReworkPage, setDisplayReworkPage] = useState(false);
  const [machineList, setMachineList] = useState([]);
  const [targetDuration, setTargetDuration] = useState(0);
  const [sizeCode, setSizeCode] = useState("");
  const [okCount, setOkCount] = useState("");
  const [rejectCount, setRejectCount] = useState("");
  const [isError, setIsError] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const formRef = useRef(null);

  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      fetchMasterList(Constants.TRANSACTION.REWORKJOBCARD.open_reworkjobcard)
    ); // userSlice store
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // const userData = useSelector((state) => state?.user);
  // const deptCodeList = userData?.data?.departments?.map(
  //   (entry) => entry.deptCode
  // );

  let masterList = useSelector((state) => state?.masterList?.page); // User Details from Store

  let completeRowsData =
    masterList[Constants.TRANSACTION.REWORKJOBCARD.name]?.data;

  let rowsData = completeRowsData;
  // if (userData?.data?.category === Constants.MASTER.USERS.TEAMLEAD) {
  //   rowsData = completeRowsData?.filter((reworkjobcard) =>
  //     deptCodeList?.includes(reworkjobcard?.toDeptCode)
  //   );
  // }

  useEffect(() => {
    let param = {};
    param.url = "getProcessMasterListDataById";
    param.page = Constants.MASTER.PROCESS.name;
    param.id = sizeCode;

    if (sizeCode) {
      dispatch(fetchMasterListById(param)).then((result) => {
        if (result?.payload?.data[0]) {
          let processFilter = result?.payload?.data[0]?.process.filter(
            (process) => process.deptCode === toDeptCode
          );
          setTargetDuration(processFilter[0]?.cycleTime * 60);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sizeCode]);

  useEffect(() => {
    let param = {};
    param.url = "getMasterListDataById";
    param.page = Constants.MASTER.MACHINES.name;
    param.id = toDeptCode;

    if (toDeptCode) {
      dispatch(fetchMasterListById(param)).then((result) => {
        let filteredMachines = result?.payload?.data.filter(
          (machine) =>
            machine.runningStatus !== "Inuse" &&
            machine.status !== Constants.MASTER.STATUS.Inactive
        );
        if (finalToMachineCode) {
          const selectedMachineRow = {
            machineCode: finalToMachineCode,
            machineName: finalToMachineName,
          };
          filteredMachines.push(selectedMachineRow);
        }
        setMachineList(filteredMachines);
      });
    }
  }, [dispatch, toDeptCode, finalToMachineCode, finalToMachineName]);

  const handleClick = (e, row) => {
    e.preventDefault();
    console.log(">> row", row);

    setDisplayReworkPage(true);
    setJobcardDetails(row);
    setToDeptCode(row.toDeptCode);
    setSizeCode(row.sizeCode);
    if (row.toMachineCode) {
      setFinalToMachineCode(row.toMachineCode);
      setFinalToMachineName(row.toMachineName);
    }
  };

  const handleButtonClick = async (action) => {
    if (isSubmitting) return;

    if (action === Constants.TRANSACTION_STATUS.COMPLETED) {
      if (
        Number(okCount ? okCount : 0) +
          Number(rejectCount ? rejectCount : 0) !==
        Number(jobcardDetails.count)
      ) {
        setIsError(true);
        setError(t("msg_trasaction.rework_jobcard.rework_error"));
        return;
      }
    } else if (action === Constants.TRANSACTION_STATUS.INPROGRESS) {
      if (!finalToMachineCode) {
        setIsError(true);
        setError(t("msg_trasaction.startstop_jobcard.select_machine"));
        return;
      }
    }

    let param = {
      ...jobcardDetails,
      toMachineCode: finalToMachineCode,
      toMachineName: finalToMachineName,
      jobcard: jobcardDetails.jobcard,
      action: action,
      reworkStatus:
        action === Constants.TRANSACTION_STATUS.COMPLETED
          ? "REWORK-COMPLETE"
          : "REWORK",
      fromDB:
        action === Constants.TRANSACTION_STATUS.INPROGRESS
          ? moment().toDate()
          : new Date(fromValue),
      toDB:
        action === Constants.TRANSACTION_STATUS.INPROGRESS
          ? ""
          : moment().toDate(),
      from:
        action === Constants.TRANSACTION_STATUS.INPROGRESS
          ? moment().format("DD-MM-YYYY HH:mm:ss")
          : fromValue,
      to:
        action === Constants.TRANSACTION_STATUS.INPROGRESS
          ? ""
          : moment().format("DD-MM-YYYY HH:mm:ss"),
      actualDuration: '',
      targetDuration: targetDuration,
      okCount,
      rejectCount,
    };
    if (action === Constants.TRANSACTION_STATUS.INPROGRESS) {
      param.startDateTime= formatDateTime(moment().format("DD-MM-YYYY HH:mm:ss"))
    }
    if (action === Constants.TRANSACTION_STATUS.STOPPED) {
      param.stopDateTime = formatDateTime(moment().format("DD-MM-YYYY HH:mm:ss"))
      const actualtime = calculateDuration(formatDateTime(jobcardDetails.startDateTime? jobcardDetails.startDateTime : moment().format("DD-MM-YYYY HH:mm:ss")), moment().format("DD-MM-YYYY HH:mm:ss"))
      if(jobcardDetails.actualDuration && typeof jobcardDetails.actualDuration === 'string'){
        param.actualDuration = addTimeStrings(jobcardDetails.actualDuration,actualtime)
      } else {
        param.actualDuration = actualtime
      }
    }
    setIsSubmitting(true);
    await ItemService.updateReworkJobcard(param).then((item) => {
      if (item?.status === 200) {
        console.log(">> item! updateReworkJobcard", item);
        setOkCount("");
        setRejectCount("");
        //message
        if (item) {
          toastFunc(Constants.MASTER.TOAST.success, item?.message, 3000);
          setJobcardDetails(item?.data);
          if (action === Constants.TRANSACTION_STATUS.INPROGRESS) {
            setFromValue(item.fromValue);
          } else if (action === Constants.TRANSACTION_STATUS.COMPLETED) {
            navigate("/home");
          }
        }
      } else {
        console.log(">> Error: Loading getApplicationMaster");
      }
    }).finally(() => setIsSubmitting(false));
  };

  const columnsData = [
    {
      name: t("msg_reports.msg_jobstatus_report.actions"),
      cell: (row) => (
        <Button className="btnTable" onClick={(e) => handleClick(e, row)}>
          {t("msg_common.Rework")}
        </Button>
      ),
      center: true,
      width: "150px",
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_jobcard"),
      selector: (row) => row.jobcard,
      sortable: true,
      width: "160px",
      center: true,
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-new-status">
            {row.jobcard}
          </span>
        </>
      ),
    },
    {
      name: t("msg_trasaction.rework_jobcard.rework_reason"),
      selector: (row) => row.reasonCode,
      sortable: true,
      center: true,
      width: "250px",
      cell: (row) => (
        <>
          {row.reasonCode ? (
            <span className="bg-table-status">
              {row.reasonCode} - {row.reasonName}
            </span>
          ) : (
            ""
          )}
        </>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_jobcard_status"),
      selector: (row) => row.jobcardStatus,
      sortable: true,
      width: "200px",
      center: true,
      cell: (row) => (
        <>
          {/* <span className="bg-table-status bg-table-new-status">
            {row.jobcardStatus}
          </span> */}
          {row.jobcardStatus === "Inprogress" ? (
            <span className="bg-table-status bg-table-progress-status">
              {row.jobcardStatus}
            </span>
          ) : row.jobcardStatus === "Open" ? (
            <span className="bg-table-status bg-table-new-status">
              {/* {row.jobcardStatus} */}
              NOT Acknowledged
            </span>
          ) : row.jobcardStatus === "Stopped" ? (
            <span className="bg-table-status bg-table-danger-status">
              {row.jobcardStatus}
            </span>
          ) : row.jobcardStatus === "Acknowledged" ? (
            <span className="bg-table-status bg-table-success-status">
              {row.jobcardStatus}
            </span>
          ) : row.jobcardStatus === "Closed" ? (
            <span className="bg-table-status bg-table-info-status">
              {row.jobcardStatus}
            </span>
          ) : row.jobcardStatus === "Complete" ? (
            <span className="bg-table-status bg-table-documentNumber-status">
              {row.jobcardStatus}
            </span>
          ) : (
            <>{row.jobcardStatus}</>
          )}
        </>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_quantity"),
      selector: (row) => row.count,
      sortable: true,
      width: "150px",
      center: true,
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-new-status">
            {row.count}
          </span>
        </>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_fromDepartment"),
      selector: (row) => row.fromDeptCode,
      sortable: true,
      center: true,
      width: "250px",
      cell: (row) => (
        <>
          {row.fromDeptCode ? (
            <span className="bg-table-status bg-table-first-status">
              {row.fromDeptCode} - {row.fromDeptName}
            </span>
          ) : (
            ""
          )}
        </>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_toDepartment"),
      selector: (row) => row.toDeptCode,
      sortable: true,
      center: true,
      width: "250px",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-second-status">
            {row.toDeptCode} - {row.toDeptName}
          </span>
        </>
      ),
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_operator"),
      selector: (row) => row.loginUserId,
      sortable: true,
      width: "180px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">
            {row.operatorUserId}- {row.operatorUserName}
          </p>
        </div>
      ),
    },
    {
      name: t("msg_trasaction.rework_jobcard.rework_assigned_to"),
      selector: (row) => row.assignedUserId,
      sortable: true,
      width: "180px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">
            {row.assignedFirstName}
          </p>
        </div>
      ),
    },
    {
      name: t("msg_common.created_date"),
      selector: (row) => row.dbDateTimeCreated,
      sortable: true,
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-datatable-row">
            {formatDateTime(row.dbDateTimeCreated)}
          </p>
        </div>
      ),
      width: "155px",
    },
    {
      name: t("msg_reports.msg_jobstatus_report.col_size"),
      selector: (row) => row.sizeCode,
      sortable: true,
      center: true,
      width: "160px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.sizeCode}</p>
        </div>
      ),
    },
    {
      name: t("msg_trasaction.msg_generatejobcard.requiredDate"),
      selector: (row) => row.requiredDate,
      sortable: true,
      center: true,
      width: "160px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{formatDate(row.requiredDate)}</p>
        </div>
      ),
    },
  ];

  return (
    <main className="acknowledgejobcard main" id="main">
      <Form noValidate ref={formRef}>
        {!displayReworkPage && (
          <Card className="">
            <Card.Header>
              <Button
                type="button"
                variant="primary"
                className="btn btn-primary btn-xs navigateBackButton"
                onClick={() => navigate("/home")}
              >
                <i class="bi bi-arrow-left back"> </i>
                <span className="back"> {t("msg_common.Back")}</span>
              </Button>

              <h5 className="reworkStatusTitle">
                {t("msg_trasaction.rework_jobcard.rework_jobcard_page")}
              </h5>
            </Card.Header>

            {rowsData?.length > 0 ? (
              <div>
                <MasterList
                  columnsData={columnsData}
                  cardHeader={false}
                  rowsData={rowsData}
                  paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                  pagination
                  handleClose
                />
              </div>
            ) : (
              <div>
                <br></br>
                <h5 className="reworkStatusTitle">
                  {t("msg_trasaction.rework_jobcard.no_rework_items")}
                </h5>
                <br></br>
              </div>
            )}
          </Card>
        )}
        {displayReworkPage && (
          <Card className="">
            <Card.Header>
              <Button
                type="button"
                variant="primary"
                className="btn btn-primary btn-xs navigateBackButton"
                onClick={() => navigate("/home")}
              >
                <i class="bi bi-arrow-left back"> </i>
                <span className="back"> {t("msg_common.Back")}</span>
              </Button>

              <h5 className="machineStatusTitle">
                {t("msg_trasaction.rework_jobcard.rework_jobcard_page")} -{" "}
                {`${jobcardDetails.jobcard}`}
              </h5>
            </Card.Header>
            <Card.Body className="ps-3">
              <Row className="ps-3 start-stop-page-header">
                <Col lg={6} md={6} sm={12}>
                  <Row>
                    <Col lg={4} md={4} sm={12}>
                      <h5>
                        {t("msg_trasaction.startstop_jobcard.from_department")}{" "}
                        :
                      </h5>
                    </Col>
                    <Col lg={8} md={8} sm={12}>
                      {jobcardDetails.fromDeptCode && (
                        <h5>
                          <span className="bg-table-status bg-table-new-status py-0">
                            {jobcardDetails.fromDeptCode}{" "}
                            {jobcardDetails.fromDeptName}
                          </span>
                        </h5>
                      )}
                    </Col>
                  </Row>
                </Col>
                <Col lg={6} md={6} sm={12}>
                  <Row>
                    <Col lg={4} md={4} sm={12}>
                      <h5>
                        {t("msg_trasaction.startstop_jobcard.to_department")} :
                      </h5>
                    </Col>
                    <Col lg={8} md={8} sm={12}>
                      <h5>
                        <span className="bg-table-status bg-table-new-status py-0">
                          {jobcardDetails.toDeptCode} -{" "}
                          {jobcardDetails.toDeptName}
                        </span>
                      </h5>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="ps-3">
                <Col lg={6} md={6} sm={12}>
                  {
                    <Row>
                      <Col lg={4} md={4} sm={12}>
                        <h5>
                          {" "}
                          {t("msg_trasaction.rework_jobcard.rework_quantity")} :
                        </h5>
                      </Col>
                      <Col lg={8} md={8} sm={12}>
                        <h5>
                          {jobcardDetails.count && (
                            <span className="bg-table-status bg-table-new-status py-0">
                              {jobcardDetails.count}
                            </span>
                          )}
                        </h5>
                      </Col>
                    </Row>
                  }
                </Col>
                <Col lg={6} md={6} sm={12}>
                  <Row>
                    <Col lg={4} md={4} sm={12}>
                      <h5>
                        {" "}
                        {t("msg_trasaction.startstop_jobcard.to_machine")} :
                      </h5>
                    </Col>
                    <Col lg={8} md={8} sm={12}>
                      <h5>
                        <DropdownListField
                          id="machineCode"
                          name="machineCode"
                          className="dropdownHive w-full rounded-md"
                          data={machineList}
                          value={finalToMachineCode}
                          onChange={(e) => {
                            setFinalToMachineCode(e.machineCode);
                            setFinalToMachineName(e.machineName);
                          }}
                          placeholder={"Select To Machine"}
                          disabled={
                            jobcardDetails?.jobcardStatus === "Inprogress"
                              ? true
                              : false
                          }
                          // disabled={disableMachineArr}
                        />
                      </h5>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <br />
              <Card>
                <Row>
                  <Col lg={6} md={6} sm={12}>
                    <ListGroup variant="flush" className="jobcard-detail-list">
                      <ListGroup.Item>
                        <span>
                          {t("msg_trasaction.msg_generatejobcard.customer")} :{" "}
                        </span>{" "}
                        {jobcardDetails.customerCode}{" "}
                      </ListGroup.Item>
                      <ListGroup.Item>
                        <span>
                          {t("msg_trasaction.msg_generatejobcard.requiredDate")}{" "}
                          :{" "}
                        </span>{" "}
                        {jobcardDetails.requiredDate}
                      </ListGroup.Item>
                      <ListGroup.Item>
                        <span>
                          {t("msg_trasaction.msg_generatejobcard.plan")} :{" "}
                        </span>{" "}
                        {jobcardDetails.plan}
                      </ListGroup.Item>
                      <ListGroup.Item>
                        <span>
                          {t("msg_trasaction.startstop_jobcard.total_quantity")}{" "}
                          :{" "}
                        </span>{" "}
                        {jobcardDetails.batchTotalQuantity}
                      </ListGroup.Item>
                      {jobcardDetails?.jobcardStatus ===
                        Constants.TRANSACTION_STATUS.ACKNOWLEDGE && (
                        <ListGroup.Item className="m-2"></ListGroup.Item>
                      )}
                    </ListGroup>
                  </Col>
                  <Col lg={6} md={6} sm={12}>
                    <ListGroup variant="flush" className="jobcard-detail-list">
                      <ListGroup.Item>
                        <span>
                          {t("msg_trasaction.msg_generatejobcard.size")} :{" "}
                        </span>{" "}
                        {jobcardDetails.sizeCode} ({jobcardDetails.sizeName})
                      </ListGroup.Item>
                      <ListGroup.Item>
                        <span>
                          {t("msg_trasaction.msg_generatejobcard.slCardNumber")}{" "}
                          :{" "}
                        </span>{" "}
                        {jobcardDetails.jobcard}
                      </ListGroup.Item>
                      <ListGroup.Item>
                        <span>
                          {t("msg_trasaction.startstop_jobcard.jobCard_number")}{" "}
                          :{" "}
                        </span>{" "}
                        {jobcardDetails.jobcard}
                      </ListGroup.Item>
                      <ListGroup.Item>
                        <span>
                          {t(
                            "msg_trasaction.msg_generatejobcard.batchQuantity"
                          )}{" "}
                          :{" "}
                        </span>{" "}
                        {jobcardDetails.quantityPerJobCard}
                      </ListGroup.Item>
                      {jobcardDetails?.jobcardStatus ===
                        Constants.TRANSACTION_STATUS.ACKNOWLEDGE && (
                        <ListGroup.Item></ListGroup.Item>
                      )}
                    </ListGroup>
                  </Col>
                </Row>
              </Card>
              {jobcardDetails?.jobcardStatus !==
                Constants.TRANSACTION_STATUS.OPEN && jobcardDetails?.jobcardStatus !==
                Constants.TRANSACTION_STATUS.ACKNOWLEDGE && (
                <Row>
                  <Col
                    className="d-flex justify-content-center"
                    lg={6}
                    md={6}
                    sm={6}
                    xs={12}
                  >
                    <Row>
                      <Col lg={8} md={8} sm={8}>
                        <h5>
                          {t(
                            "msg_trasaction.rework_jobcard.rework_ok_quantity"
                          )}{" "}
                          :
                        </h5>
                      </Col>
                      <Col lg={4} md={4} sm={4}>
                        <InputField
                          type="number"
                          className={"commLeftRightPadding"}
                          width={25}
                          value={okCount}
                          onChange={(e) => {
                            if (e.target.value) {
                              setOkCount(e.target.value);
                            }
                          }}
                        />
                      </Col>
                    </Row>
                  </Col>

                  <Col
                    className="d-flex justify-content-center"
                    lg={6}
                    md={6}
                    sm={6}
                    xs={12}
                  >
                    <Row>
                      <Col lg={8} md={8} sm={8}>
                        <h5>
                          {t(
                            "msg_trasaction.rework_jobcard.rework_reject_quantity"
                          )}{" "}
                          :
                        </h5>
                      </Col>
                      <Col lg={4} md={4} sm={4}>
                        <InputField
                          type="number"
                          className={"commLeftRightPadding"}
                          width={25}
                          value={rejectCount}
                          onChange={(e) => {
                            if (e.target.value) {
                              setRejectCount(e.target.value);
                            }
                          }}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}
            </Card.Body>
            <Card.Footer className="text-center machine-status-footer-button">
              <Button
                type="button"
                variant="warning"
                size="lg"
                className="btn btn-warning"
                onClick={() =>
                  handleButtonClick(Constants.TRANSACTION_STATUS.ACKNOWLEDGE)
                }
                data-dismiss="modal"
                disabled={
                  isSubmitting || !(
                    jobcardDetails?.jobcardStatus ===
                    Constants.TRANSACTION_STATUS.OPEN
                  )
                }
              >
                {t("msg_common.Acknowledge")}
              </Button>
              <Button
                type="button"
                variant="success"
                size="lg"
                className="btn btn-success"
                onClick={() =>
                  handleButtonClick(Constants.TRANSACTION_STATUS.INPROGRESS)
                }
                data-dismiss="modal"
                disabled={
                  isSubmitting || !(
                    jobcardDetails?.jobcardStatus ===
                      Constants.TRANSACTION_STATUS.STOPPED ||
                    jobcardDetails?.jobcardStatus ===
                      Constants.TRANSACTION_STATUS.ACKNOWLEDGE
                  )
                }
              >
                {t("msg_common.start")}
              </Button>

              <Button
                type="button"
                variant="warning"
                size="lg"
                className="btn btn-warning"
                onClick={() =>
                  handleButtonClick(Constants.TRANSACTION_STATUS.STOPPED)
                }
                data-dismiss="modal"
                disabled={
                  isSubmitting || !(
                    jobcardDetails?.jobcardStatus ===
                    Constants.TRANSACTION_STATUS.INPROGRESS
                  )
                }
              >
                {t("msg_common.stop")}
              </Button>
              <Button
                type="button"
                variant="success"
                size="lg"
                className="btn btn-success"
                onClick={() =>
                  handleButtonClick(Constants.TRANSACTION_STATUS.COMPLETED)
                }
                data-dismiss="modal"
                disabled={
                  isSubmitting || !(
                    jobcardDetails?.jobcardStatus ===
                    Constants.TRANSACTION_STATUS.STOPPED
                  )
                }
              >
                {t("msg_common.complete")}
              </Button>

              <Button
                type="button"
                variant="danger"
                size="lg"
                className="btn btn-danger"
                onClick={() => navigate("/home")}
                data-dismiss="modal"
              >
                {t("msg_common.set_cancel")}
              </Button>
            </Card.Footer>
          </Card>
        )}
      </Form>
      {isError && (
        <AlertModal
          show={isError}
          heading={t("msg_common.alert")}
          bodyMessage={error}
          onHide={() => {
            setIsError(false);
          }}
        ></AlertModal>
      )}
    </main>
  );
};

export default ReworkJobCard;
